var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"active-calls d-none",staticStyle:{"background":"#fff"}},_vm._l((_vm.$store.state.sip.calls),function(call,index){return _c('div',{key:'ac-' + index,staticClass:"d-flex"},[_c('ActiveCall',{attrs:{"phone":index,"active-call":call}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }